// extracted by mini-css-extract-plugin
export default {"bacKBtn":"HeaderAction_bacKBtn__u8VIo","wrapper":"HeaderAction_wrapper__Q6Git","title":"HeaderAction_title__IBkoc"};